import { useEffect } from "react";
import { useNavigate } from "react-router";
import { ApiError } from "../api/client";

/**
 * The server said the free questions are spent.
 *
 * 402 rather than 403: the student is allowed to be here, they just have not
 * paid. Matching on the status keeps the client from guessing at error
 * messages.
 */
export function isUpgradeRequired(error: unknown): boolean {
  return error instanceof ApiError && error.status === 402;
}

/**
 * Send the student to the wall when the server says they have hit it.
 *
 * The wall is where the ₦5,000 payment lives, and hitting the end of the trial
 * is the moment it makes sense to ask. Before this, nothing routed anyone
 * there: the screen existed and no code path reached it.
 */
export function useUpgradeOnPaywall(error: unknown): void {
  const navigate = useNavigate();

  useEffect(() => {
    if (isUpgradeRequired(error)) void navigate("/upgrade", { replace: true });
  }, [error, navigate]);
}
